import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';
// eslint-disable-next-line
import { useOpen } from 'useful-state';
import axios from 'axios';
import { map, sortBy } from 'lodash';

const ProductsFilterLoader = ({ route, children }) => {
  const [state, setState] = React.useState();

  const shape = (d, key) =>
    sortBy(
      map(d.data[key], ({ name, code }) => ({
        label: name,
        value: code,
      })),
      'label',
    );

  React.useEffect(() => {
    axios
      .get(`/q3-api-${route}?limit=500`)
      .then((data) => {
        setState(shape(data, route));
      })
      .catch(() => {
        setState([]);
      });
  }, []);

  return state ? children(state) : <CircularProgress />;
};

ProductsFilterLoader.propTypes = {
  children: PropTypes.func.isRequired,
  route: PropTypes.string.isRequired,
};

export default ProductsFilterLoader;
